// noinspection SpellCheckingInspection

// import sampleProperty from "./sampleData/sampleProperty";
// import sampleProperty from "./sampleData/samplePropertyTwo";
import sampleProperty from "./sampleData/sampleProperty181";

export default {
  property: sampleProperty,
  networkUid: '32ef472a-f7d6-4482-b377-f36c5739ed61',
  appleMapKitToken: "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjkzMjhDQjI4NzIifQ.eyJpc3MiOiJHRjNHVlBGVE45IiwiaWF0IjoxNjQyNzk2NDk0LCJleHAiOjE2NDI5NjkyOTR9.sUql3SxWjpsce6icqxET3smTC97Au1qH0EapzOnSH0AqlpgZzborVm6rFo-te8yz0NJo_NITLyncCiKvZr9HIw",
  authToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2OTQyMDE4OTMsImFwaV9rZXkiOiJkVVc3ekJad2Z3YUo5cFZBalBIamZWa04iLCJ3ZWJzaXRlX2lkIjo1NjIzfQ.mHPEg1Vo5OIl4LzXxGUj4BPOUspw_QI0iyP80NtLhbw'
}
